module.exports = __webpack_public_path__ + "img/box_2.07df4e5d.png";